export function normalizeKey(key: string): string {
  return key
    .normalize('NFD') // quita tildes
    .replace(/[\u0300-\u036f]/g, '') // remueve diacríticos
    .replace(/\s+/g, '_') // reemplaza espacios por guiones bajos
    .replace(/[^\w]/g, '') // remueve cualquier carácter que no sea letra/número/_
    .toLowerCase(); // convierte a minúsculas
}
